<div class="text-center">

  <h1 mat-dialog-title translate> {{title}} </h1>
  <div class="modal-body" mat-dialog-content>
    <p [innerHTML]="body | translate"></p>
    
    <ng-container *ngIf="confirm_code === true">
      <mat-form-field>
        <mat-label translate class = "mt-3"> {{confirm_code_text}} </mat-label>
        <input [(ngModel)] = "code" matInput>
      </mat-form-field>
    </ng-container>

  </div>
  <div class="modal-footer" mat-dialog-actions translate>
    <button type="button" class="btn btn-outline-danger" (click)="cancel()" translate [hidden]="hideCancel">
     {{cancel_text}}
    </button>
    <button type="button" class="btn btn-outline-secondary"
      (click)="continue()" translate>
      {{confirm_text}}
    </button>
  </div>
</div>